import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProcedureTypeSettingsGeneralViewTopBar } from "./TopBar"

export const procedureTypeSettingsGeneralViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProcedureTypeSettingsGeneralViewTopBar,
}
